;(function () {
  'use strict'

  angular.module('contrast.shared.groups').constant('GROUP_TYPE', {
    DEFAULT: 'DEFAULT',
    CUSTOM: 'CUSTOM'
  })
})()
